module.exports = __webpack_public_path__ + "static/media/logoSASS.bf1057cd.svg";